import { ConfigurationType, DesignRuleValidationIssue } from 'data/types';
import { generateConfigurationSections } from 'utils/ui';
import { isErrorSeverity } from 'utils/validation';

export type ConfigurationDotStatus = 'valid' | 'warning' | 'error';

export function getConfigurationDotStatus(
  configIndex: number,
  config: ConfigurationType,
  isActive: boolean,
  activeDesignRuleResults: DesignRuleValidationIssue[]
): ConfigurationDotStatus {
  const sections = generateConfigurationSections(configIndex);
  const steps = sections.filter((s) => s.requirementsMet !== undefined);
  const finished =
    steps.length > 0 && steps.every((s) => s.requirementsMet === true);

  if (isActive) {
    if (activeDesignRuleResults.some((r) => isErrorSeverity(r.severity))) {
      return 'error';
    }
    if (
      !finished ||
      activeDesignRuleResults.some((r) => !isErrorSeverity(r.severity))
    ) {
      return 'warning';
    }
    return 'valid';
  }

  if (config.valid === false) return 'warning';
  if (!finished) return 'warning';
  return 'valid';
}
